import { Components, Theme } from "@mui/material";
import { Shades } from "style/Colors";

export const MuiSvgIcon: Components<Theme>["MuiSvgIcon"] = {
  styleOverrides: {
    colorDisabled: {
      color: Shades.gray30,
    },
  },
};
